import { render } from "./ConfirmSignUp.vue?vue&type=template&id=438dbb7f&scoped=true"
import script from "./ConfirmSignUp.vue?vue&type=script&lang=js"
export * from "./ConfirmSignUp.vue?vue&type=script&lang=js"

import "./ConfirmSignUp.vue?vue&type=style&index=0&id=438dbb7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438dbb7f"]])

export default __exports__